import { Injectable } from '@angular/core'

export const LOCAL_TOKEN = 'token'
export const LOCAL_CLIENT_ID = 'clientId'
export const LOCAL_REFRESH_TOKEN = 'LOCAL_REFRESH_TOKEN'

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
	// 3_600_000 equal 1h in miliseconds
	setTime(key: string, data: string, expirationTime: number) {
		// Set the item in localStorage
		localStorage.setItem(key, data)

		// Set the expiration time in localStorage
		localStorage.setItem(`${key}_TIME`, String(expirationTime))
	}

	getTime(key: string) {
		const storedTime = localStorage.getItem(`${key}_TIME`)
		const currentTime = new Date().getTime()

		if (Number(storedTime) < currentTime) {
			// Item has expired
			localStorage.removeItem(key)
			localStorage.removeItem(`${key}_TIME`)
			return null
		}
		// Item has not expired, retrieve the data
		return localStorage.getItem(key)
	}

	deleteTime(key: string) {
		localStorage.removeItem(key)
		localStorage.removeItem(`${key}_TIME`)
	}
}
